import { Component } from "@angular/core";

@Component({
    selector: "page-prueba",
    templateUrl: "./prueba.component.html",
    styleUrls: ["./prueba.component.css"]
    
})


export class PruebaComponent {

    constructor(){
       
    }

     
}